package com.example.mystybag.sharedmodels.project.responseModels.merchant

import kotlinx.serialization.Serializable

/** Rating details for a location: overall rating, review count, and 4 category breakdown (see ReviewCategoryConfigs). */
@Serializable
data class LocationRatingResponseModel(
    val averageRating: Double? = null,
    val reviewCount: Int = 0,
    val ratingCategory1: Double? = null,
    val ratingCategory2: Double? = null,
    val ratingCategory3: Double? = null,
    val ratingCategory4: Double? = null
)
